import Icon from "@ant-design/icons";
import { ReactComponent as YoutubeSvg } from "./svg/youtube.svg";

const YoutubeIcon = (props) => <Icon component={YoutubeSvg} {...props} />;

export default YoutubeIcon;
